module.exports = __webpack_public_path__ + "static/img/m_role.d2e547a.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/xk/m_role.png
// module id = J2rn
// module chunks = 7